/** @format */

import { Action, createReducer, on } from '@ngrx/store';
import { InvalidResponse, ProductReviewsProsConsState } from '../../model';
import {
	removeSelectedFeature,
	setProductReviewCons,
	setProductReviewPros,
	setProductReviewProsCons,
	setSelectedFeature
} from '../actions';

export const initialProductReviewsProsConsState: ProductReviewsProsConsState = {
	cons: [],
	pros: [],
	selectedFeature: new InvalidResponse()
};

export const productReviewsProsConsReducers = createReducer(
	initialProductReviewsProsConsState,
	on(setProductReviewCons, (state, { cons }) => ({
		...state,
		cons
	})),
	on(setProductReviewPros, (state, { pros }) => ({
		...state,
		pros
	})),
	on(setProductReviewProsCons, (state, { cons, pros }) => ({
		...state,
		cons,
		pros
	})),
	on(setSelectedFeature, (state, { selectedFeature }) => ({
		...state,
		selectedFeature
	})),
	on(removeSelectedFeature, (state) => ({
		...state,
		selectedFeature: null
	}))
);

export const productReviewsProsConsReducer = (state: ProductReviewsProsConsState, action: Action) =>
	productReviewsProsConsReducers(state, action);
